<template>
  <div>
     <van-popup v-model ="showPop" position="bottom" >
        <van-search v-model="searchKey" placeholder="请输入仓库编号/名称" @input="loadData"/>
        <van-form style="margin-top:10px">
          <van-list  
            :finished ="finishedLoading"
            finished-text="没有更多了"
            style="height:400px;overflow: scroll;"
          >
            <van-cell v-for="item in data" :key="item.id" :title="item.name" @click="onItemClick(item)"  :class="item.select?'select':'unselect'">
            </van-cell>
          </van-list>

          <van-submit-bar type="info" button-text="确认" @submit="select" v-if="!isSingle">
          </van-submit-bar>
        </van-form>
        
    </van-popup>
  </div>
</template>

<script>
import { getStores } from '@/api/wms/index.js'

export default {
  name: 'StoresSelectDialog',
  props:{
    isSingle:false,
    propsFilter:null
  },
  components: {
  },
  computed: {
  },
  data() {
    return {
        data:[],
        showPop:false,
        searchKey:'',
        finishedLoading:false
    };
  },
  mounted(){
    
  },
  methods: {
    loadData(){
      getStores(this.searchKey).then(res=>{
        if(res.code == 200){
          this.data = res.data;

          if(this.propsFilter){
            this.data = this.data.filter(o=> o.storeProp == this.propsFilter)
          }
        } 
        else{
          this.data = [];
        }

        this.data.forEach(o=>{
          o.select = false;
        })

        this.finishedLoading = true;
      })
    },
    open(){
      this.showPop = true;
      this.loadData();
    },
    onItemClick(item){
      if(this.isSingle){
        this.$emit('select',[item][0]);
        this.showPop = false;
        return;
      }

      item.select = !item.select;
      this.$forceUpdate();
    },
    select(){
      let selectItems = this.data.filter(o=> o.select);
      this.$emit('select',selectItems[0]);
      this.showPop = false;
    }
  }
};
</script>

<style lang="less" scoped>
.select{
  color:dodgerblue
}
</style>
